export default "__VITE_ASSET__CyuueZiE__"